import React, { forwardRef, memo, useCallback } from 'react';
import { InputCustom, InputMasked } from './styled';

interface Props {
  mask: string;
  type?: 'text' | 'password' | 'hidden';
  variant?: any;
  color?: 'primary' | 'secondary';
  className?: string;
  multiline?: boolean;
  minRows?: number;
  maxRows?: number;
  label: string;
  name?: string;
  value: string;
  onChange?: any;
  error?: boolean;
  helperText?: any;
  disabled?: boolean;
}

const InputMaskPhone = forwardRef<any, any>((props, ref) => {
  const { inputRef, ...other } = props;

  const phoneMask = (value: string) => {
    const numbers = value.replace(/\D/g, '');
    const length = numbers.length;

    if (length <= 10) {
      return [
        '(', /[1-9]/, /\d/, ')', ' ',
        /\d/, /\d/, /\d/, /\d/, '-',
        /\d/, /\d/, /\d/, /\d/
      ];
    } else {
      return [
        '(', /[1-9]/, /\d/, ')', ' ',
        /\d/, /\d/, /\d/, /\d/, /\d/, '-',
        /\d/, /\d/, /\d/, /\d/
      ];
    }
  };

  // Callback ref que recebe a instância do InputMasked
  const handleMaskedRef = useCallback((node: any) => {
    if (!node) return;

    // Obtém o elemento <input> real (dependendo da biblioteca, pode ser node.inputElement)
    const inputElement = node.inputElement || node;

    // Repassa para a inputRef recebida do Material-UI
    if (inputRef) {
      if (typeof inputRef === 'function') {
        inputRef(inputElement);
      } else if (typeof inputRef === 'object') {
        inputRef.current = inputElement;
      }
    }

    // Repassa para a ref do forwardRef (também do Material-UI)
    if (ref) {
      if (typeof ref === 'function') {
        ref(inputElement);
      } else if (typeof ref === 'object') {
        ref.current = inputElement;
      }
    }
  }, [inputRef, ref]);

  return (
    <InputMasked
      {...other}
      ref={handleMaskedRef}          // usa ref para capturar a instância
      mask={phoneMask}
      placeholderChar={'\u2000'}
      guide={false}
    />
  );
});

const inputMask = (mask: string) => {
  if (mask === 'phone') {
    return InputMaskPhone;
  }
  return undefined;
};

const InputTextMasked: React.FC<Props> = ({
  mask,
  type,
  multiline,
  minRows,
  maxRows,
  variant,
  className,
  color,
  label,
  name,
  value,
  onChange,
  error,
  helperText,
  disabled,
}) => (
  <InputCustom
    type={type || 'text'}
    multiline={multiline || false}
    maxRows={maxRows || ''}
    minRows={minRows || ''}
    variant={variant || 'outlined'}
    className={className || ''}
    color={color}
    label={label}
    name={name}
    value={value}
    onChange={onChange}
    error={error}
    helperText={helperText}
    autoComplete="off"
    disabled={disabled}
    InputProps={{
      inputComponent: inputMask(mask),
    }}
  />
);

export default memo(InputTextMasked);